"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eggs = void 0;
var pikachu_1 = __importDefault(require("./eggs/pikachu"));
var bravo_1 = __importDefault(require("./eggs/bravo"));
var ghost_1 = __importDefault(require("./eggs/ghost"));
var britney_1 = __importDefault(require("./eggs/britney"));
var pikarun_1 = __importDefault(require("./eggs/pikarun"));
var catrun_1 = __importDefault(require("./eggs/catrun"));
var koggy_1 = __importDefault(require("./eggs/koggy"));
var sonic_1 = __importDefault(require("./eggs/sonic"));
var doggy_1 = __importDefault(require("./eggs/doggy"));
var spongebob_1 = __importDefault(require("./eggs/spongebob"));
var gun_1 = __importDefault(require("./eggs/gun"));
var money_1 = __importDefault(require("./eggs/money"));
var homer_1 = __importDefault(require("./eggs/homer"));
var dog_1 = __importDefault(require("./eggs/dog"));
var bird_1 = __importDefault(require("./eggs/bird"));
var piqiu_1 = __importDefault(require("./eggs/piqiu"));
var lol_1 = __importDefault(require("./eggs/lol"));
var ohhh_1 = __importDefault(require("./eggs/ohhh"));
var nyancat_1 = __importDefault(require("./eggs/nyancat"));
var salamander_1 = __importDefault(require("./eggs/salamander"));
var airguitar_1 = __importDefault(require("./eggs/airguitar"));
var dragon_1 = __importDefault(require("./eggs/dragon"));
var psyduck_1 = __importDefault(require("./eggs/psyduck"));
var piggy_1 = __importDefault(require("./eggs/piggy"));
var sensei_1 = __importDefault(require("./eggs/sensei"));
var rabbit_1 = __importDefault(require("./eggs/rabbit"));
var joker_1 = __importDefault(require("./eggs/joker"));
var mario_1 = __importDefault(require("./eggs/mario"));
var fox_1 = __importDefault(require("./eggs/fox"));
var jump_1 = __importDefault(require("./eggs/jump"));
var tank_1 = __importDefault(require("./eggs/tank"));
var winner_1 = __importDefault(require("./eggs/winner"));
var handsome_1 = __importDefault(require("./eggs/handsome"));
var penguin_1 = __importDefault(require("./eggs/penguin"));
var swim_1 = __importDefault(require("./eggs/swim"));
var thankyou_1 = __importDefault(require("./eggs/thankyou"));
var earth_1 = __importDefault(require("./eggs/earth"));
var fly_1 = __importDefault(require("./eggs/fly"));
var snorlax_1 = __importDefault(require("./eggs/snorlax"));
var board_1 = __importDefault(require("./eggs/board"));
var haters_1 = __importDefault(require("./eggs/haters"));
var onmyway_1 = __importDefault(require("./eggs/onmyway"));
var no_1 = __importDefault(require("./eggs/no"));
var kirby_1 = __importDefault(require("./eggs/kirby"));
var hangover_1 = __importDefault(require("./eggs/hangover"));
var balloon_1 = __importDefault(require("./eggs/balloon"));
var cool_1 = __importDefault(require("./eggs/cool"));
var walk_1 = __importDefault(require("./eggs/walk"));
var ufo_1 = __importDefault(require("./eggs/ufo"));
var pie_1 = __importDefault(require("./eggs/pie"));
var pokeball_1 = __importDefault(require("./eggs/pokeball"));
var hippo_1 = __importDefault(require("./eggs/hippo"));
var hiphop_1 = __importDefault(require("./eggs/hiphop"));
var robot_1 = __importDefault(require("./eggs/robot"));
var bat_1 = __importDefault(require("./eggs/bat"));
var travel_1 = __importDefault(require("./eggs/travel"));
var haha_1 = __importDefault(require("./eggs/haha"));
var kumamon_1 = __importDefault(require("./eggs/kumamon"));
var unicorn_1 = __importDefault(require("./eggs/unicorn"));
var wink_1 = __importDefault(require("./eggs/wink"));
var hi_1 = __importDefault(require("./eggs/hi"));
var snake_1 = __importDefault(require("./eggs/snake"));
var unicorncursor_1 = __importDefault(require("./eggs/unicorncursor"));
var nyan_1 = __importDefault(require("./eggs/nyan"));
exports.eggs = [
    pikachu_1.default,
    bravo_1.default,
    ghost_1.default,
    britney_1.default,
    pikarun_1.default,
    catrun_1.default,
    koggy_1.default,
    sonic_1.default,
    doggy_1.default,
    spongebob_1.default,
    gun_1.default,
    money_1.default,
    homer_1.default,
    dog_1.default,
    bird_1.default,
    piqiu_1.default,
    lol_1.default,
    ohhh_1.default,
    nyancat_1.default,
    salamander_1.default,
    airguitar_1.default,
    dragon_1.default,
    psyduck_1.default,
    piggy_1.default,
    sensei_1.default,
    rabbit_1.default,
    joker_1.default,
    mario_1.default,
    fox_1.default,
    jump_1.default,
    tank_1.default,
    winner_1.default,
    handsome_1.default,
    penguin_1.default,
    swim_1.default,
    thankyou_1.default,
    earth_1.default,
    fly_1.default,
    snorlax_1.default,
    board_1.default,
    haters_1.default,
    onmyway_1.default,
    no_1.default,
    kirby_1.default,
    hangover_1.default,
    balloon_1.default,
    cool_1.default,
    walk_1.default,
    ufo_1.default,
    pie_1.default,
    pokeball_1.default,
    hippo_1.default,
    hiphop_1.default,
    robot_1.default,
    bat_1.default,
    travel_1.default,
    haha_1.default,
    kumamon_1.default,
    unicorn_1.default,
    wink_1.default,
    hi_1.default,
    snake_1.default,
    unicorncursor_1.default,
    nyan_1.default,
];
